import React from 'react';
import Layout from '@/sections/Layout';

import Hero from '@/sections/pages/About/Hero';
import Glance from '@/sections/pages/About/Glance';
import Banner from '@/sections/common/Banner';
import Benefits from '@/sections/pages/About/Benefits';
import Business from '@/sections/pages/About/Business';
import Research from '@/sections/pages/About/Research';
import Industry from '@/sections/pages/About/Industry';
import Leadership from '@/sections/pages/About/Leadership';
import Careers from '@/sections/pages/About/Careers';
import Connect from '@/sections/pages/About/Connect';
import Blog from '@/sections/pages/About/Blog';

import AboutData from '@/mocks/aboutData';

const About = () => {
  return (
    <Layout
      currentPageClass={'cr-about-page'}
      headerClass={'cr-about-header'}
      mainClass={'cr-about-main'}
      footerClass={'cr-about-footer'}
    >
      {(commonData) => (
        <>
          <Hero data={AboutData.hero} />
          <Glance data={AboutData.glance} />
          <Banner data={AboutData.banner} />
          <Benefits data={AboutData.benefits} />
          <Business data={AboutData.business} />
          <Research data={AboutData.research} />
          <Industry data={AboutData.industry} />
          <Leadership data={AboutData.leadership} />
          <Careers data={AboutData.careers} />
          <Connect data={AboutData.connect} />
          <Blog data={AboutData.blog} />
        </>
      )}
    </Layout>
  );
};

export default About;
